import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';

class Footer extends Component {
  render() {
    const { Buttons, title, text, linkText } = this.props.t || {};
    return (
      <div>
        <div className="foot-top">
          <div className="container">
            <a href="# ">{Buttons.toTop}</a>
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="foot-content">
              <div className="site-title">
                <h3>euprava.gov.rs</h3>
                <p>{title}</p>
              </div>
              <div className="copy">
                {text}{' '}
                <Link href="https://www.ite.gov.rs/" target="_blank" to="#">
                  ite.gov.rs
                </Link>
              </div>
              <ul className="nav">
                <li className="emph">
                  <Link
                    href="https://euprava.gov.rs/uslovi_koriscenja"
                    target="_blank"
                    onClick={(event) => {
                      event.preventDefault();
                      window.open('https://euprava.gov.rs/uslovi_koriscenja');
                    }}
                    to="#"
                  >
                    {linkText}
                  </Link>
                </li>
              </ul>
            </div>
            <ul className="foot-social">
              <li className="fb pr-1">
                <Link
                  href="https://www.facebook.com/KancelarijaITE/"
                  target="_blank"
                  to="#"
                >
                  Facebook
                </Link>
              </li>
              <li className="tw pr-1">
                <Link
                  href="https://twitter.com/kancelarijaITE"
                  target="_blank"
                  to="#"
                >
                  Twitter
                </Link>
              </li>
              <li className="py">
                <Link
                  href="https://www.youtube.com/user/euprava"
                  target="_blank"
                  to="#"
                >
                  Play
                </Link>
              </li>
            </ul>
          </div>
        </footer>
      </div>
    );
  }
}

export default withTranslations(Footer, 'Footer');
